import { Form, Input, Radio } from "antd";
import { capitalize } from "lodash";
import React, { useEffect } from "react";
import PhoneInput from "react-phone-number-input";
import useCrmIntegration from "../../hooks/useCrmIntegration";
import { toTitleCase } from "../../utils";
import "./leadCenter.css";

/**
 *
 * @param {{form:import("antd").FormInstance}} param0
 * @returns
 */

export default function LeadCustomerInformationForm({
  leadData,
  setleadData,
  primaryPhoneType,
  setprimaryPhoneType,
  phoneArr,
  primaryEmailType,
  setprimaryEmailType,
  emailTypes,
  form,
}) {
  const crmIntegration = useCrmIntegration();
  const handleChangePhone = (e, key) => {
    setleadData(prev => {
      const temp = structuredClone(prev);
      const index = temp.phones.findIndex(item => toTitleCase(item.phoneType) === key);
      if (index !== -1)
        temp.phones[index] = {
          ...temp.phones[index],
          phone: e,
          phoneType: key,
        };
      else {
        temp.phones.push({
          phone: e,
          phoneType: key,
        });
      }
      return temp;
    });
  };
  const getPhoneValue = key => {
    // console.log("LeadCustomerInformationForm:getPhoneValue:key", key, "leadData", leadData);
    return leadData.phones.find(item => toTitleCase(item.phoneType) === key)?.phone;
  };

  console.log(leadData);
  useEffect(() => {
    if (leadData.phones && leadData.phones.length > 0) {
      const primaryPhone = leadData.phones.find(item => item.isPrimary);
      if (primaryPhone) {
        setprimaryPhoneType(primaryPhone.phoneType);
      }
    }
  }, [leadData.phones]);
  useEffect(() => {
    if (leadData.emails && leadData.emails.length > 0) {
      const primaryEmail = leadData.emails.find(item => item.isPrimary);
      if (primaryEmail) {
        setprimaryEmailType(primaryEmail.emailType);
      }
    }
  }, [leadData.emails]);
  /**
   *
   * @param {{emailType:string, email:string}[]} input
   * @returns
   */
  const serializeEmail = input => {
    const result = {};
    // Iterate over each object in the array
    input.forEach(item => {
      // Get the key of the current object (e.g., "Mobile" or "Work")
      const key = Object.keys(item)[0];
      // Assign the value to the result object
      result[item[key]] = item.email;
    });
    return result;
  };

  const resetEmailFields = () => {
    // Extract only email-related field names
    const emailFieldNames = emailTypes.map(type => `${type}_EMAIL`);
    form.resetFields(emailFieldNames); // Reset only email fields
  };
  useEffect(() => {
    if (leadData.emails && leadData.emails.length > 0) {
      resetEmailFields();
      const emailValues = emailTypes.reduce((acc, type) => {
        const emailTypeData = leadData.emails.find(el => el?.emailType === type);
        acc[`${type}_EMAIL`] = emailTypeData ? emailTypeData?.email : "";
        return acc;
      }, {});

      form.setFieldsValue(emailValues);
    } else {
      resetEmailFields();
    }
  }, [leadData.emails]);

  const getEmail = type => {
    const email = leadData?.emails?.find(email => email.emailType === type);
    return email;
  };
  const setEmail = (value, type) => {
    setleadData(prev => {
      const temp = structuredClone(prev);
      const index = temp.emails.findIndex(
        item => toTitleCase(item.emailType) === toTitleCase(type)
      );
      if (index !== -1)
        temp.emails[index] = {
          ...temp.emails[index],
          email: value,
          emailType: type,
        };
      else {
        temp.emails.push({
          email: value,
          emailType: type,
        });
      }
      return temp;
    });
  };
  return (
    <div className="flex flex-wrap ">
      <span className="bg-[#F8FAFC] p-2 w-full text-sm font-[600] text-grey-700 ">
        Personal Details
      </span>
      <div className="flex justify-between w-full flex-wrap">
        <Form.Item
          className="w-[48%]"
          name="firstName"
          rules={[{ required: true, message: "First name is required" }]}
          label="First Name"
        >
          <Input
            name="firstName"
            value={leadData.firstName}
            placeholder="Enter first name"
            onChange={e => setleadData({ ...leadData, firstName: e.target.value })}
          />
        </Form.Item>
        <Form.Item
          className="w-[48%]"
          name="lastName"
          rules={[{ required: true, message: "Last name is required" }]}
          label="Last Name"
        >
          <Input
            name="lastName"
            placeholder="Enter last name"
            value={leadData.lastName}
            onChange={e => setleadData({ ...leadData, lastName: e.target.value })}
          />
        </Form.Item>
        <Radio.Group
          value={primaryEmailType}
          onChange={e => setprimaryEmailType(e.target.value)}
          className="flex-col-centered items-center w-full"
        >
          {emailTypes.map((item, index) => (
            <div key={index} className="flex-row-centered gap-2 justify-between w-full">
              <Form.Item
                rules={[
                  {
                    required: primaryEmailType === item,
                    message: `Please enter the ${capitalize(item)} email`,
                  },
                  { type: "email", message: `Enter a valid ${capitalize(item)} email` },
                ]}
                label={`Email (${capitalize(item)})`}
                name={`${item}_EMAIL`}
                className="w-full"
                key={`${item}_EMAIL`}
              >
                <Input
                  className="w-full"
                  value={getEmail(item)?.email || ""}
                  onChange={e => setEmail(e.target.value, item)}
                  name={`${item}_EMAIL`}
                  placeholder={`Enter ${capitalize(item)} email`}
                />
              </Form.Item>
              <Radio className="mt-4" value={item} />
            </div>
          ))}
        </Radio.Group>
        <Radio.Group
          value={primaryPhoneType}
          onChange={e => setprimaryPhoneType(e.target.value)}
          className="flex-col-centered items-center w-full"
        >
          {phoneArr.map((item, index) => (
            <Form.Item
              key={index}
              className="w-full"
              name={item}
              rules={[
                {
                  required: item === primaryPhoneType,
                  message: `${item} Phone number is required`,
                },
              ]}
              label={`Phone (${item})`}
            >
              <div className="flex-row-centered items-center justify-between gap-2 w-full">
                <PhoneInput
                  value={getPhoneValue(item)}
                  onChange={e => handleChangePhone(e, item)}
                  className="lead-form-phone w-full "
                  placeholder={`Enter ${item} number`}
                  name={item}
                />
                <Radio value={item} />
              </div>
            </Form.Item>
          ))}
        </Radio.Group>
        <span className="bg-[#F8FAFC] p-2 w-full text-sm font-[600] text-grey-700 ">
          Communication Details
        </span>
        <Form.Item
          className="w-full"
          name="addressLine1"
          // rules={[{ required: true, message: "Primary Address is required" }]}
          label="Address Line 1"
        >
          <Input
            name="addressLine1"
            placeholder="Enter Address Line 1"
            value={leadData.addressLine1}
            onChange={e => setleadData({ ...leadData, addressLine1: e.target.value })}
          />
        </Form.Item>
        <Form.Item className="w-full" name="addressLine2" label="Address Line 2">
          <Input
            name="addressLine2"
            placeholder="Enter Address Line 2"
            value={leadData.addressLine2}
            onChange={e => setleadData({ ...leadData, addressLine2: e.target.value })}
          />
        </Form.Item>
        <Form.Item
          className="w-full"
          name="city"
          // rules={[{ required: true, message: "City is required" }]}
          label="City"
        >
          <Input
            name="city"
            placeholder="Enter City"
            value={leadData.city}
            onChange={e => setleadData({ ...leadData, city: e.target.value })}
          />
        </Form.Item>
        <Form.Item
          className="w-[48%]"
          name="state"
          // rules={[{ required: true, message: "State is required" }]}
          label="State"
        >
          <Input
            name="state"
            placeholder="Enter State"
            value={leadData.state}
            onChange={e => setleadData({ ...leadData, state: e.target.value })}
          />
        </Form.Item>
        <Form.Item
          className="w-[48%]"
          name="postalCode"
          // rules={[{ required: true, message: "Postal Code is required" }]}
          label="Postal Code"
        >
          <Input
            type="number"
            name="postalCode"
            placeholder="Enter Postal Code"
            value={leadData.postalCode}
            onChange={e => setleadData({ ...leadData, postalCode: e.target.value })}
          />
        </Form.Item>
        <Form.Item
          className="w-full"
          name="country"
          // rules={[{ required: true, message: "Country is required" }]}
          label="Country"
        >
          <Input
            name="country"
            placeholder="Enter Country"
            value={leadData.country}
            onChange={e => setleadData({ ...leadData, country: e.target.value })}
          />
        </Form.Item>
      </div>
    </div>
  );
}
